import React, { FunctionComponent, useEffect, useState } from 'react';
import { Checkbox } from '@blueprintjs/core';

type Callback = (value: any) => void;

interface IsScheduleFilterProps {
  onChange: Callback;
  reset: boolean;
}

const IsScheduleFilter: FunctionComponent<IsScheduleFilterProps> = ({
  onChange,
  reset,
}) => {
  const [ selected, setSelected ] = useState<any>(false);

  useEffect(() => {
    if (reset) {
      setSelected(false);
    }
  }, [ reset ]);

  const onCheckboxChange = (event: any) => {
    const value = (event.target as any).checked
    setSelected(value);
    onChange(value);
  }

  return (
    <Checkbox
      label="Is Schedule"
      name="is_schedule"
      checked={selected}
      onChange={onCheckboxChange}
    />
  )
};

export default IsScheduleFilter;
